"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSecureRelForTarget = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");
/**
 * Secures outbound links. See https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
 * for more info.
 */


var getSecureRelForTarget = function getSecureRelForTarget(target, rel) {
  if (!target) {
    return rel;
  }

  if (!target.includes('_blank')) {
    return rel;
  }

  if (!rel) {
    return 'noopener noreferrer';
  }

  var secureRel = rel;

  if (!secureRel.includes('noopener')) {
    secureRel = "".concat(secureRel, " noopener");
  }

  if (!secureRel.includes('noreferrer')) {
    secureRel = "".concat(secureRel, " noreferrer");
  }

  return secureRel.trim();
};

exports.getSecureRelForTarget = getSecureRelForTarget;